export function forceStyleRecalculation(element) {
    return element.offsetWidth >= 0;
}
//# sourceMappingURL=forceStyleRecalculation.js.map